import { createTheme } from '@mui/material';

const sharedTypography = {
  fontFamily: 'lato',
  h1: {
    fontSize: '32px',
    fontWeight: 900,
    color: '#fff',
  },
  h2: {
    fontSize: '24px',
    fontWeight: 700,
    fontFamily: 'butler',
  },
  h3: {
    fontSize: '20px',
    fontWeight: 700,
    fontFamily: 'lato',
  },
  h6: {
    fontSize: '12px',
    fontWeight: 700,
    fontFamily: 'lato',
  },
  body1: {
    fontSize: '14px',
    fontWeight: 400,
    fontFamily: 'lato',
    lineHeight: '20px',
  },
  body2: {
    fontSize: '13px',
    fontWeight: 400,
    fontFamily: 'lato',
  },
  subtitle1: {
    fontSize: '13px',
    fontWeight: 500,
    fontFamily: 'lato',
  },
  subtitle2: {
    fontSize: '12px',
    fontWeight: 500,
    fontFamily: 'lato',
  },
  button: {
    textTransform: 'initial',
    fontFamily: 'lato',
  },
};

export const Theme = createTheme({
  palette: {
    primary: {
      main: '#BC172F',
    },
  },
  typography: sharedTypography,
});

export const ThemeTerrace = createTheme({
  palette: {
    primary: {
      main: '#013709',
    },
  },
  typography: sharedTypography,
});

export const ThemeForno = createTheme({
  palette: {
    primary: {
      main: '#1d2b1a',
    },
  },
  typography: sharedTypography,
});

export const ThemePrive = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#ffffff',
      contrastText: '#000000',
    },
    background: {
      default: '#000000',
      paper: '#111111',
    },
    text: {
      primary: '#ffffff',
      secondary: '#a3a3a3',
    },
    divider: '#2a2a2a',
    action: {
      disabledBackground: '#2a2a2a',
    },
  },
  typography: {
    ...sharedTypography,
    h1: {
      ...sharedTypography.h1,
      color: '#ffffff',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: '#ffffff',
          color: '#000000',
          '&:hover': {
            backgroundColor: '#e5e5e5',
          },
        },
        containedPrimary: {
          backgroundColor: '#ffffff',
          color: '#000000',
          '&:hover': {
            backgroundColor: '#e5e5e5',
          },
        },
        outlined: {
          borderColor: '#ffffff',
          color: '#ffffff',
          '&:hover': {
            borderColor: '#e5e5e5',
            backgroundColor: 'rgba(255,255,255,0.04)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#000000',
          color: '#ffffff',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& fieldset': {
            borderColor: '#2a2a2a',
          },
          '&:hover fieldset': {
            borderColor: '#ffffff',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#a3a3a3',
          '&.Mui-checked': {
            color: '#ffffff',
          },
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: '#2a2a2a',
        },
        bar: {
          backgroundColor: '#ffffff',
        },
      },
    },
  },
});

export const ThemeNok = createTheme({
  palette: {
    mode: 'light',

    primary: {
      main: '#AE5830',
      contrastText: '#FFFFFF',
    },

    background: {
      default: '#FAF8F6',
      paper: '#FFFFFF',
    },

    text: {
      primary: '#241612',
      secondary: '#786A64',
    },

    divider: '#E8DED9',

    action: {
      disabledBackground: '#E8DED9',
      disabled: '#A89A94',
    },
  },

  typography: {
    ...sharedTypography,

    h1: {
      ...sharedTypography.h1,
      color: '#241612',
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: '#AE5830',
          color: '#FFFFFF',

          '&:hover': {
            backgroundColor: '#934823',
          },

          '&:disabled': {
            backgroundColor: '#E8DED9',
            color: '#A89A94',
          },
        },

        containedPrimary: {
          backgroundColor: '#AE5830',
          color: '#FFFFFF',

          '&:hover': {
            backgroundColor: '#934823',
          },
        },

        outlined: {
          borderColor: '#AE5830',
          color: '#AE5830',

          '&:hover': {
            borderColor: '#934823',
            backgroundColor: 'rgba(174, 88, 48, 0.06)',
          },
        },
      },
    },

    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: '#241612',
          boxShadow: '0 1px 4px rgba(36, 22, 18, 0.08)',
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',

          '& fieldset': {
            borderColor: '#DED2CC',
          },

          '&:hover fieldset': {
            borderColor: '#AE5830',
          },

          '&.Mui-focused fieldset': {
            borderColor: '#AE5830',
            borderWidth: '1px',
          },
        },
      },
    },

    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#B8AAA3',

          '&.Mui-checked': {
            color: '#AE5830',
          },
        },
      },
    },

    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: '#E8DED9',
        },

        bar: {
          backgroundColor: '#AE5830',
        },
      },
    },
  },
});
